import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class AssignPercentagesError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AssignPercentagesError', ...args);
    }
}
export default AssignPercentagesError;
